require('./basicTablePagination.style.scss');

class BasicTablePaginationController {
    constructor($scope) {
        this._$scope = $scope;
        this._$scope.$watch(() => this.startIndex, () => {
            this.firstSelectedIndex = this.startIndex;
        });
        this._$scope.$watch(() => this.endIndex, () => {
            this.lastSelectedIndex = this.endIndex;
        });
    }

    getNext() {
        if(this.waitResponseFlag) return;
        if ((this.lastSelectedIndex < this.totalEntities)) {
            this.page++;
            this.firstSelectedIndex = this.lastSelectedIndex + 1;
            if (this.totalEntities > this.lastSelectedIndex + this.count) {
                this.lastSelectedIndex = this.lastSelectedIndex + this.count;
            } else {
                this.lastSelectedIndex = this.lastSelectedIndex + (this.totalEntities - this.lastSelectedIndex);
            }
        }
    }

    getPrev() {
        if(this.waitResponseFlag) return;
        if ((this.firstSelectedIndex >= this.startIndex)) {
            this.page--;
            this.lastSelectedIndex = this.firstSelectedIndex - 1;
            this.firstSelectedIndex = this.firstSelectedIndex - this.count;
        }
    }
}

const basicTablePaginationComponent = {
    controller: BasicTablePaginationController,
    controllerAs: 'btpCtrl',
    template: require('./basicTablePagination.template.html'),
    bindings: {
        startIndex: '<',
        endIndex: '<',
        totalEntities: '<',
        grandTotalEntities: '<',
        count: '<',
        page: '=',
        waitResponseFlag: '='
    }
};

BasicTablePaginationController.$inject = ['$scope'];

module.exports = basicTablePaginationComponent;



// WEBPACK FOOTER //
// ./src/shared/basicTablePagination/basicTablePagination.component.js